module.exports = __webpack_public_path__ + "static/img/1003.61dd03e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/templates/1003.png
// module id = 732
// module chunks = 0 1 12